
var productShares = document.querySelectorAll(".social-sharing .icon-button:not(.copy-button)");
if (productShares.length > 0) {
  for (let i = 0; i < productShares.length; ++i) {
    productShares[i].addEventListener('click', (e) => {
      e.preventDefault();
      window.open(e.target.href, "_blank", "width=600,height=400");
    }, true)
  }
}
